import { render, staticRenderFns } from "./tbm.vue?vue&type=template&id=e118f232"
import script from "./tbm.vue?vue&type=script&lang=js"
export * from "./tbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e118f232')) {
      api.createRecord('e118f232', component.options)
    } else {
      api.reload('e118f232', component.options)
    }
    module.hot.accept("./tbm.vue?vue&type=template&id=e118f232", function () {
      api.rerender('e118f232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbm.vue"
export default component.exports